import { render, staticRenderFns } from "./product-aggregation-page.vue?vue&type=template&id=1f58a2c6&scoped=true"
import script from "./product-aggregation-page.vue?vue&type=script&lang=js"
export * from "./product-aggregation-page.vue?vue&type=script&lang=js"
import style0 from "./product-aggregation-page.vue?vue&type=style&index=0&id=1f58a2c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58a2c6",
  null
  
)

export default component.exports